interface CatalogTypeProps {
  entityType?: {
    title: string;
    img_url?: string;
  };
  size?: number;
}

export const CatalogType = ({ entityType, size = 30 }: CatalogTypeProps) => {
  if (!entityType) {
    entityType = {
      title: 'Unknown',
    };
  }

  let image = null;
  if (entityType.img_url) {
    image = (
      <img
        alt={entityType.title}
        src={entityType.img_url}
        style={{
          maxHeight: size + 'px',
          maxWidth: size + 'px',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      />
    );
  }
  return (
    <div style={{ lineHeight: size + 'px' }}>
      <div
        style={{
          position: 'relative',
          width: size + 'px',
          height: size + 'px',
          marginRight: 10,
          float: 'left',
        }}
      >
        {image}
      </div>
      {entityType.title}
    </div>
  );
};
